// extracted by mini-css-extract-plugin
module.exports = {"postFooter":"styles-module--postFooter--2UaPH","callToAction":"styles-module--callToAction--3aGOf"};